/**
 * Legal pages on the marketing site, linked from the signup checkbox and the
 * terms prompt (task 05). Each opens in a new tab. The legal text is never
 * embedded in the app: the site is the source of truth, and the version the
 * backend records is set in template.yaml (TermsCurrentVersion), not here.
 */
export interface LegalLink {
  /** Visible link text */
  label: string;
  /** Page URL (opens in a new tab) */
  href: string;
}

export const LEGAL_LINKS: readonly LegalLink[] = [
  { label: 'Terms of Service', href: 'https://www.gopropwise.com/terms/' },
  { label: 'Privacy Policy', href: 'https://www.gopropwise.com/privacy/' },
] as const;

/** Plans and prices, on the marketing site. Linked from the landing page. */
export const PRICING_URL = 'https://www.gopropwise.com/pricing/';

/**
 * Every policy the public pages link to, in the AuthCard footer: the two the
 * signup checkbox accepts plus the refund policy. The payment provider
 * approves a checkout domain only when its pages link to all three (task 28),
 * and a reviewer who cannot sign in sees only /login and /signup. The refund
 * policy is not part of what the checkbox accepts, so it stays out of
 * LEGAL_LINKS.
 */
export const POLICY_LINKS: readonly LegalLink[] = [
  ...LEGAL_LINKS,
  { label: 'Refund Policy', href: 'https://www.gopropwise.com/refund-policy/' },
] as const;
